import { NavigationFooter } from "../Navigation/NavigationFooter";
import { ButtonSocialNetworks } from "../Button/ButtonSocialNetworks";
import { FadeInOnScroll } from "../FadeInOnScoll/FadeInOnScroll";

export const Footer = () => {
  return (
    <div className="bg-gray py-5 lg:py-12 text-sm">
      <FadeInOnScroll delay={200}>
        <div className="flex flex-col items-center mb-8 md:mb-0">
          <NavigationFooter />
          <ButtonSocialNetworks variant="footer" />
        </div>
      </FadeInOnScroll>
      <FadeInOnScroll delay={400}>
        <div className="flex flex-col md:flex-row justify-between items-center text-xs">
          <div className="text-center md:text-left md:ml-8 mb-2 md:mb-0">
            © {new Date().getFullYear()} DUO DURAND-LELUDEC/DANIEL
          </div>
          <div className="text-center md:text-right md:mr-8">
            <a
              href="#/"
              target="_blank"
              rel="noreferrer"
              className="hover:underline"
            >
              DESIGNED BY JONATHAN DANIEL
            </a>
          </div>
        </div>
      </FadeInOnScroll>
    </div>
  );
};
